import { inject, Injectable } from '@angular/core';
import { AppShellService as CommonAppShellService } from '@iot-platform/feature/app-shell';
import { AppName } from '@iot-platform/models/common';
import { SidenavMenuBlock } from '@iot-platform/models/i4b';
import { map, Observable } from 'rxjs';
import { AuthorizationService } from '../../features/auth/services/authorization.service';
import { NavigationsFacade } from '../../features/navigations/state/facades/navigations.facade';

@Injectable({
  providedIn: 'root'
})
export class AppShellService extends CommonAppShellService {
  protected readonly authorizationService: AuthorizationService = inject(AuthorizationService);
  protected readonly navigationsFacade: NavigationsFacade = inject(NavigationsFacade);

  override get appName() {
    return AppName.OYAN;
  }

  override getNavigationTree(): Observable<SidenavMenuBlock[]> {
    return super.getNavigationTree().pipe(map((navTree) => this.authorizationService.getNavigationTree(navTree)));
  }

  override handleBusinessProfileChange() {
    super.onBusinessProfileChange();
    this.navigationsFacade.onBusinessProfileChanged(true);
  }
}
